import parsePhoneNumberFromString from "libphonenumber-js";
import config from "../config";
import { apiInstance } from "./AppApis";
import { toast } from "react-toastify";
import { validateUSAddress } from "../services/geocodingService";

let lastToastTimestamps = {};
const TOAST_COOLDOWN = 5000; // 5 seconds

export function showErrorToast(message, options = {}) {
    const now = Date.now();
    const lastTime = lastToastTimestamps[message] || 0;

    if (now - lastTime > TOAST_COOLDOWN) {
        toast.error(message, {
            pauseOnHover: false,
            autoClose: 3000,
            ...options, // allow overriding
        });
        lastToastTimestamps[message] = now;
    }
}
export function showSuccessToast(message, options = {}) {
    const now = Date.now();
    const lastTime = lastToastTimestamps[message] || 0;

    if (now - lastTime > TOAST_COOLDOWN) {
        toast.success(message, {
            pauseOnHover: false,
            autoClose: 3000,
            ...options, // allow overriding
        });
        lastToastTimestamps[message] = now;
    }
}

export function downloadFile(url, filename, setLoading, setIndex) {
    setLoading(true);
    fetch(url)
        .then((response) => response.blob())
        .then((blob) => {
            const url = URL.createObjectURL(blob);
            const anchor = document.createElement("a");
            anchor.href = url;
            anchor.download = filename;
            anchor.click();
            URL.revokeObjectURL(url); // Cleanup
            setLoading(false);
            setIndex(null);
        })
        .catch((error) => {
            console.error("Error downloading file:", error);
            setLoading(false);
            setIndex(null);
        });
}
// export function downloadFile(url, filename) {
//     // Create a hidden anchor element
//     const anchor = document.createElement('a');
//     // Set the URL and filename for download
//     anchor.href = url;
//     anchor.download = filename;
//     anchor.target = "_blank"; // Open in new tab
//     anchor.rel = "noopener noreferrer"; // Security best practice
//     document.body.appendChild(anchor);
//     // Trigger a click on the anchor element
//     anchor.click();

//     // Clean up
//     document.body.removeChild(anchor);
//   }

// Give Time Ago formate
export default function getTimeAgo(dateString) {
    const inputDate = new Date(dateString);
    const now = new Date();
    const diffMs = now.getTime() - inputDate.getTime();

    const seconds = Math.floor(diffMs / 1000);
    const minutes = Math.floor(seconds / 60);
    const hours = Math.floor(minutes / 60);
    const days = Math.floor(hours / 24);
    const weeks = Math.floor(days / 7);
    const months = Math.floor(days / 30);
    const years = Math.floor(days / 365);

    if (years > 0) return `${years} year${years > 1 ? "s" : ""} ago`;
    if (months > 0) return `${months} month${months > 1 ? "s" : ""} ago`;
    if (weeks > 0) return `${weeks} week${weeks > 1 ? "s" : ""} ago`;
    if (days > 0) return `${days} day${days > 1 ? "s" : ""} ago`;
    if (hours > 0) return `${hours} hour${hours > 1 ? "s" : ""} ago`;
    if (minutes > 0) return `${minutes} minute${minutes > 1 ? "s" : ""} ago`;
    if (seconds >= 5) return `${seconds} seconds ago`;

    return `Just now`;
}

// formatter date
export function formatDate(timestampStr) {
    const timestamp = new Date(timestampStr);
    const currentDate = new Date();
    if (
        timestamp.getDate() === currentDate.getDate() &&
        timestamp.getMonth() === currentDate.getMonth() &&
        timestamp.getFullYear() === currentDate.getFullYear()
    ) {
        const diffMinutes = Math.round((currentDate - timestamp) / (1000 * 60));
        if (diffMinutes < 60 && diffMinutes > 1) {
            return `${diffMinutes} min`;
        }
        if (diffMinutes < 1) {
            return "Now";
        }
        if (diffMinutes > 60 && diffMinutes === 60) {
            const diffHours = Math.round(diffMinutes / 60);
            return `${diffHours} Hr`;
        }
    }
    const yesterday = new Date(currentDate);
    yesterday.setDate(currentDate.getDate() - 1);
    if (
        timestamp.getDate() === yesterday.getDate() &&
        timestamp.getMonth() === yesterday.getMonth() &&
        timestamp.getFullYear() === yesterday.getFullYear()
    ) {
        const options = {
            hour: "2-digit",
            minute: "2-digit",
            hour12: true,
        };
        return "Yesterday " + timestamp.toLocaleTimeString("en-US", options);
    }
    if (timestamp.getMonth() === currentDate.getMonth() && timestamp.getFullYear() === currentDate.getFullYear()) {
        const options = {
            weekday: "short",
            hour: "2-digit",
            minute: "2-digit",
            hour12: true,
        };
        return timestamp.toLocaleDateString("en-US", options);
    }
    const options = {
        day: "2-digit",
        month: "short",
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
    };
    return timestamp.toLocaleDateString("en-US", options);
}

export const download = async (fileName) => {
    try {
        const response = await fetch(`${config.get("IMAGE_BASE_URL")}${fileName}`);
        const blob = await response.blob();
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", fileName);
        document.body.appendChild(link);
        link.click();
        link.remove();
    } catch (error) {
        console.error("Error downloading file:", error);
    }
};

export const getFormattedTime = (dateString) => {
    const date = new Date(dateString); // Parse ISO string (UTC)
    const hours = date.getHours(); // Local hours (adjusted to user's timezone)
    const minutes = String(date.getMinutes()).padStart(2, "0"); // Local minutes

    const period = hours >= 12 ? "PM" : "AM";
    const formattedHours = hours % 12 || 12; // Convert to 12-hour format

    return `${formattedHours}:${minutes} ${period}`;
};

export const refreshAccessToken = async () => {
    try {
        const refreshToken = localStorage.getItem("refreshToken");
        if (!refreshToken) throw new Error("No refresh token available");
        const { data } = await apiInstance.post(
            "/user/refresh_token",
            {
                refresh_token: refreshToken.replace(/^"|"$/g, ""),
            },
            {
                headers: { Authorization: `Bearer ${refreshToken.replace(/^"|"$/g, "")}` },
            }
        );

        if (data?.access_token) {
            localStorage.setItem("authUser", JSON.stringify(data.access_token));
            if (data.refresh_token) {
                localStorage.setItem("refreshToken", JSON.stringify(data.refresh_token));
            }
            return data.access_token;
        } else {
            window.location.href = `${config.get("FRONT_END_URL")}/login`;
            throw new Error("Failed to refresh access token");
        }
    } catch (error) {
        // console.error("Error refreshing token:", error);
        localStorage.removeItem("authUser");
        localStorage.removeItem("refreshToken");
        return null;
    }
};

export function isValidUSNumber(number) {
    const phoneNumber = parsePhoneNumberFromString(number, "US");
    return phoneNumber?.isValid() && phoneNumber?.country === "US";
}

// Enhanced phone validation function for consistent use across all services
export function validateUSPhoneNumber(phoneNumber) {
    if (!phoneNumber || typeof phoneNumber !== "string") {
        return false;
    }

    // Remove all non-digit characters for validation
    const digitsOnly = phoneNumber.replace(/\D/g, "");

    // Check if it's a valid US number using libphonenumber-js (most reliable)
    const parsedNumber = parsePhoneNumberFromString(phoneNumber, "US");
    if (!parsedNumber?.isValid() || parsedNumber?.country !== "US") {
        return false;
    }

    // Check for invalid prefixes (000, 001, 002, 011 - these are not valid US area codes)
    if (isInvalidPrefix(phoneNumber)) {
        return false;
    }

    // Check for repeated digits (like 1111111111)
    const isRepeatedDigits = (number) => {
        const digits = number.replace(/\D/g, "");
        return /^(\d)\1{9,}$/.test(digits); // 9 or more repeats after first digit
    };

    if (isRepeatedDigits(phoneNumber)) {
        return false;
    }

    // Additional check: US phone numbers should have exactly 10 digits (without country code)
    // or 11 digits if they include the country code (1)
    const nationalNumber = parsedNumber.nationalNumber;
    if (nationalNumber.length !== 10) {
        return false;
    }

    // Area code and exchange code should not start with 0 or 1 (US phone number rules)
    const areaCode = nationalNumber.substring(0, 3);
    const exchangeCode = nationalNumber.substring(3, 6);

    if (areaCode[0] === "0" || areaCode[0] === "1" || exchangeCode[0] === "0" || exchangeCode[0] === "1") {
        return false;
    }

    return true;
}
export const isInvalidPrefix = (value) => {
    console.log(value);
    const prefix = value.slice(1, 4);
    const invalidPrefixes = ["000", "001", "002", "011"];
    return invalidPrefixes.includes(prefix);
};

export const isUSAddress = async (address) => {
    try {
        // Use new geocoding service instead of direct Google Maps API call
        return await validateUSAddress(address);
    } catch (error) {
        console.error("Error validating US address:", error);
        return false;
    }
};
